module.exports = __webpack_public_path__ + "assets/images/close.140ecdc8.svg";